export default __webpack_public_path__ + "static/media/product-service-bg.6aec4dcb.jpg";